export default __webpack_public_path__ + "static/media/dialog-event.5ab760a4.svg";